import { render, staticRenderFns } from "./TestQuestionList.vue?vue&type=template&id=1bdd1948&scoped=true"
import script from "./TestQuestionList.vue?vue&type=script&lang=js"
export * from "./TestQuestionList.vue?vue&type=script&lang=js"
import style0 from "./TestQuestionList.vue?vue&type=style&index=0&id=1bdd1948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd1948",
  null
  
)

export default component.exports